import type { Moment } from 'moment';
import {
  getDaysCount,
  getWeekendsCount,
  isAfterSomeHour,
  isOnlyRegularDays,
} from './dateHelpers';

interface PricesConfig {
  perAboveWeek: number;
  perWeekendDay: number;
  perRegularDay: number;
}

interface RentalDetails {
  endDate?: Moment;
  prices: PricesConfig;
  startDate?: Moment;
}

export const calculatePrice = ({
  startDate,
  endDate,
  prices,
}: RentalDetails): number => {
  if (!startDate || !endDate || !startDate.isValid() || !endDate.isValid()) {
    throw new Error('Please provide valid dates');
  }

  if (startDate.isAfter(endDate)) {
    throw new Error('Start date cannot be greater than or equal to end date');
  }
  const isAfter3PM = isAfterSomeHour(startDate, 14, 50);
  const _startDate = isAfter3PM ? startDate.add(1, 'days') : startDate;
  const _endDate = isAfter3PM ? endDate.add(1, 'days') : endDate;
  const daysCount = getDaysCount(_startDate, endDate);
  switch (true) {
    case isOnlyRegularDays(_startDate, _endDate) && daysCount < 7: {
      return prices.perRegularDay * daysCount;
    }
    case !isOnlyRegularDays(_startDate, _endDate) && daysCount < 7: {
      const weekendsCount = getWeekendsCount(_startDate, _endDate);
      const remainingDays = daysCount - weekendsCount;
      return (
        remainingDays * prices.perRegularDay +
        weekendsCount * prices.perWeekendDay
      );
    }

    case daysCount >= 7: {
      return daysCount * prices.perAboveWeek;
    }
    default: {
      return 0;
    }
  }
};
